export const examinationRoute = process.env.REACT_APP_EXAMINATION_ROUTE_ID as string;
export const practitionerRoute = process.env.REACT_APP_PRACTITIONER_ROUTE_ID as string;
export const executiveRoute = process.env.REACT_APP_EXECUTIVE_ROUTE_ID  as string;
export const academicRoute = process.env.REACT_APP_ACADEMIC_ROUTE_ID as string;
export const militaryRoute = process.env.REACT_APP_MILITARY_ROUTE_ID as string;
export const corporateRoute = process.env.REACT_APP_CORPORATE_ROUTE_ID as string;
export const academicRouteB = process.env.REACT_APP_ACADEMIC_ROUTE_B_ID as string
export const militaryRouteB = process.env.REACT_APP_MILITARY_ROUTE_B_ID as string;

export const categoryA = process.env.REACT_APP_MILITARY_CATEGORY_A as string;
export const categoryB = process.env.REACT_APP_MILITARY_CATEGORY_B as string;